import { type ImageLoaderProps } from 'next/image';

                                                                                                                                                                                 
                                       
const resMode = 'sharp2';                                                                                                                                                                                
const unsharpMask = '1.75,0.3,2,0';                                                                                                                                                                       

const imageLoader = ({ quality = 75, src, width }: ImageLoaderProps) => {
  const url = new URL(src, 'https://waitrose-prod.scene7.com');

  url.searchParams.delete('scl');                                                                  

  for (const [k, v] of Object.entries({
    fmt: 'jpg',
    op_usm: unsharpMask,
    qlt: quality,
    resMode,
    wid: width,
  })) {
    url.searchParams.set(k, v.toString());
  }

                                                                                   
  return url.toString().replaceAll('%2C', ',');
};

export default imageLoader;
